import React from 'react';
import PropertyList from './PropertyList';

const NodeDetails = ({node, values}) => (
    <>
        <PropertyList nodeId={node.id} items={node.properties} values={values} />
    </>
);

export default NodeDetails;
